import produce from 'immer';
import { OkAction, ErrorAction } from '../../actions/baseActions';
import { UserMessage } from '../../types/common';

interface UserMessageReducerState {
  messages: UserMessage[];
}

const initialState: UserMessageReducerState = {
  messages: [],
};

const isErrorAction = (
  action: OkAction<string, string> | ErrorAction<string>,
): action is ErrorAction<string> => 'error' in action;

const handleOkAction = (state: UserMessageReducerState, action: OkAction<string, string>) =>
  produce(state, (draft) => {
    draft.messages.push(action.userMessage as UserMessage);
  });

const handleErrorAction = (state: UserMessageReducerState, action: ErrorAction<string>) =>
  produce(state, (draft) => {
    draft.messages.push({
      translationKey: action.type,
      translationSubkey: action.subCode,
      errorMessage: action.displayOriginalError ? action.error : undefined,
      showSnackbar: action.showSnackbar,
      type: action.userMessageVariant || 'danger',
    });
  });

const userMessageReducer = (
  state = initialState,
  action: OkAction<string, string> | ErrorAction<string>,
) => {
  if (!isErrorAction(action) && action.userMessage) {
    return handleOkAction(state, action);
  }
  if (isErrorAction(action) && action.error) {
    return handleErrorAction(state, action);
  }
  return state;
};

export default userMessageReducer;
